import React, { useState } from 'react';
import Slider from 'react-slick';
import { SliderLeftIcon, SliderRightIcon } from '../../../Icons';

const ApplicationTabSlider = ({ applicationTabsList, defaultTab, setDefaultTab }) => {
  const [hideRightArrow, setHideRightArrow] = useState(false);

  const SampleNextArrow = (props) => {
    const { onClick } = props;
    return (
      <div className="custom-next-arrow right" onClick={onClick}>
        <SliderRightIcon />
      </div>
    );
  };

  const SamplePrevArrow = (props) => {
    const { onClick } = props;
    return (
      <div className="custom-next-arrow " onClick={onClick}>
        <SliderLeftIcon />
      </div>
    );
  };


  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    variableWidth: true,
    afterChange: (current) => {
      const totalSlides = 7;
      const visibleSlides = 5;
      if (current + visibleSlides >= totalSlides) {
        setHideRightArrow(true);
      } else {
        setHideRightArrow(false);
      }
    },
    nextArrow: hideRightArrow ? <></> : <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  return (
    <Slider className={(applicationTabsList?.length ?? 0) > settings.slidesToShow ? "" : "static"} {...settings}  >
      {applicationTabsList?.map((tab, index) => (
        <div
          key={index}
          className={`slider-tab ${defaultTab === tab.id_link ? 'active' : ''}`}
          onClick={() => setDefaultTab(tab.id_link)}
        >
          {tab.title} <span className="numbercount"> {tab.count} </span>
        </div>
      ))}
    </Slider>
  );
};

export default ApplicationTabSlider;

